export default function Spacer({ height, clasName }) {
  return <div className={clasName} style={{ height: height ? height : 0 }}></div>;
}
